import { useState } from "react";

const faqs = [
  {
    question: "Where can I buy a box locally?",
    answer: (
      <>
        We are extremely excited and proud to announce that we will be offering
        our seasonal gift boxes in the gift shop at the historic Duwamish
        Longhouse on Marginal Way in Seattle. 4705 W Marginal Way SW, Seattle,
        WA 98106<br />
        <br />
        <strong>OPEN 5 days a week!</strong><br />
        Tuesday 10AM–5PM<br />
        Wednesday 10AM–5PM<br />
        Thursday 10AM–5PM<br />
        Friday 10AM–5PM<br />
        Saturday 10AM–5PM
      </>
    ),
  },
  {
    question: "Can I purchase a box to be shipped?",
    answer:
      "Yes, just make that selection when you place your order online and all new orders will be shipped out within 3 days.",
  }
];

export default function BoxFaq2() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <h2 className="text-2xl text-[#A00C24] sm:text-3xl font-semibold text-center mb-8">FAQs</h2>
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border text-[#A00C24] rounded-2xl p-4 sm:p-6 transition-shadow hover:shadow-md bg-white"
          >
            <button
              onClick={() => toggle(index)}
              className="w-full text-left flex justify-between items-start sm:items-center gap-2"
            >
              <span className="text-base sm:text-lg font-medium text-gray-900">
                {faq.question}
              </span>
              <span className="text-[#A00C24] text-xl sm:text-2xl leading-none">
                {openIndex === index ? "−" : "+"}
              </span>
            </button>
            {openIndex === index && (
              <div className="mt-3 text-sm sm:text-base text-gray-600 leading-relaxed">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
